import { combineReducers } from "@reduxjs/toolkit";
import { filtersSlice, filtersSliceSelectors } from "./filters-slice";
import { notesState } from "./notes-slice";
import { notesSelectors } from "./notes-selectors";

export const contactIdeasReducer = combineReducers({
  filters: filtersSlice.reducer,
  notes: notesState.reducer,
});

export const ideasPageActions = {
  ...filtersSlice.actions,
  ...notesState.actions,
};

export const ideasPageSelectors = {
  ...filtersSliceSelectors,
  ...notesSelectors,
};
